import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useBlocker } from "react-router-dom";
import logo from "../assets/images/coyote-logo.jpg";
import {
  OverlayTrigger,
  Popover,
  Button,
  Form,
  Table,
  Row,
  Col,
  Modal,
  Spinner,
} from "react-bootstrap";
import "./bom.css";
import axios from "axios";
import url from "../configs/config";
import { jwtDecode } from "jwt-decode";
import FadeLoaderComponent from "../components/loader-component";
import { roleTypes } from "../data/roleType";
import AddProductsModal from "./models/add-products-model";
import Select from "react-select";
import { Link } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import AlertNotificationSimple from "./alert/alert-notification-simple";
import * as SettingSelector from "../store/setting/selectors";
import { useSelector } from "react-redux";
import { Edit } from "lucide-react";
import { RotatingLines } from "react-loader-spinner";
import html2pdf from "html2pdf.js";

const JobBomEdit = () => {
  const { id: jobId, bomId } = useParams();
  const navigate = useNavigate();
  const alertRef = useRef(null);
  const printContentRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [bomData, setBomData] = useState({});
  const [bomInfo, setBomInfo] = useState({});
  const [totals, setTotals] = useState({
    totalProducts: 0,
    totalRequired: 0,
    totalAvailable: 0,
    totalToOrder: 0,
  });
  const [decodedToken, setDecodedToken] = useState();
  const token = localStorage.getItem("coyote-token");
  const [showPopoverItem, setShowPopoverItem] = useState(null);
  const [deleteIsSubmit, setDeleteIsSubmit] = useState(true);
  const [jobName, setJobName] = useState("");

  const [productsViewModel, setProductsViewModel] = useState(false);
  const [newProducts, setNewProducts] = useState([]);
  const [initialNewProducts, setInitialNewProducts] = useState([]);
  const [systems, setSystems] = useState([]);
  const [phases, setPhases] = useState([]);
  const [optionsSystem, setOptionsSystem] = useState([]);
  const [selectedProductListIds, setSelectedProductListIds] = useState([]);
  const [activeSystemId, setActiveSystemId] = useState(null);
  const [activePhaseId, setActivePhaseId] = useState(null);
  const [searchNewProducts, setSearchNewProducts] = useState("");
  const [selectedSystemForFilter, setSelectedSystemForFilter] = useState(null);
  const [selectedPhaseForFilter, setSelectedPhaseForFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const permissions = useSelector(SettingSelector.set_permissions);
  const [phaseLoader, setPhaseLoader] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editingQty, setEditingQty] = useState("");
  const [isUpdatingQty, setIsUpdatingQty] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingAvailability, setIsSubmittingAvailability] =
    useState(false);
  const [isUpdateAvailabilityEnabled, setIsUpdateAvailabilityEnabled] =
    useState(false);
  const hasBomEditPermission = permissions?.job?.edit_bom === true;
  const hasBomCreatePRPermission = permissions?.job?.create_bom_pr === true;
  const hasBomPrintPermission = permissions?.job?.print_bom === true;
  const productRequestHasViewPermission =
    permissions?.product_request?.view === true;
  const productRequestHasDeletePermission =
    permissions?.product_request?.delete === true;
  const productRequestHasUpdatePermission =
    permissions?.product_request?.update === true;
  const productRequestHasStatusPermission =
    permissions?.product_request?.status === true;

  const [isLoadingMoreNewProducts, setIsLoadingMoreNewProducts] =
    useState(false);
  const [sortConfigNewProducts, setSortConfigNewProducts] = useState({
    key: "productName",
    direction: "asc",
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [isMerging, setIsMerging] = useState(false);
  const [recentlyAddedProducts, setRecentlyAddedProducts] = useState(new Set());
  const [fadingProducts, setFadingProducts] = useState(new Set());

  const [showCreatePRModal, setShowCreatePRModal] = useState(false);
  const [isCreatingPR, setIsCreatingPR] = useState(false);

  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const isEditingAllowed = () => {
    const jobInfoStatus = bomInfo?.jobInfoStatus?.toLowerCase();
    const jobStatus = bomInfo?.jobStatus?.toLowerCase();
    const bomStatus = bomInfo?.bomStatus?.toLowerCase();

    if (jobInfoStatus === "inactive" || jobInfoStatus === "in-active") {
      return false;
    }

    if (jobStatus !== "pending" && jobStatus !== "in-progress") {
      return false;
    }

    if (bomStatus !== "created" && bomStatus !== "availability-checked") {
      return false;
    }

    return true;
  };

  const createUniqueKey = (productId, systemId, phaseId) => {
    return `${productId}-${systemId || "null"}-${phaseId || "null"}`;
  };
  const [validationErrors, setValidationErrors] = useState({});
  const MAX_QUANTITY_ALLOWED = 99999;
  const validateNewProducts = () => {
    const errors = {};

    const existingQuantityMap = new Map();
    Object.keys(bomData).forEach((systemName) => {
      const systemProducts = bomData[systemName] || [];
      systemProducts.forEach((existingItem) => {
        const key = createUniqueKey(
          existingItem.productId,
          existingItem.systemId,
          existingItem.phaseId
        );
        existingQuantityMap.set(key, existingItem.qtyRequired || 0);
      });
    });

    newProducts.forEach((item, index) => {
      const uniqueKey = createUniqueKey(
        item.productId,
        item.systemId,
        item.phaseId
      );
      const itemErrors = {};

      if (
        !item.quantity ||
        item.quantity === "" ||
        parseInt(item.quantity) <= 0
      ) {
        itemErrors.quantity = "Quantity is required and must be greater than 0";
      }

      if (item.rate === "" || item.rate === null || item.rate === undefined || parseFloat(item.rate) <= 0) {
        itemErrors.rate = "Rate must be greater than 0";
      }

      if (!item.systemId) {
        itemErrors.systemId = "System is required";
      }

      if (item.systemId && !item.phaseId) {
        itemErrors.phaseId = "Phase is required when system is selected";
      }

      if (item.quantity && parseInt(item.quantity) > 0) {
        const existingQuantity = existingQuantityMap.get(uniqueKey) || 0;
        const newQuantity = parseInt(item.quantity);
        const totalQuantity = existingQuantity + newQuantity;
        const maxAdditional = Math.max(
          MAX_QUANTITY_ALLOWED - existingQuantity,
          0
        );

        if (totalQuantity > MAX_QUANTITY_ALLOWED) {
          itemErrors.quantity = `Maximum quantity allowed is ${MAX_QUANTITY_ALLOWED} per product per system per phase. You can add up to ${maxAdditional} more.`;
        }
      }

      if (Object.keys(itemErrors).length > 0) {
        errors[uniqueKey] = itemErrors;
      }
    });

    return errors;
  };

  const mergeProducts = (existingProducts, newProducts) => {
    const existingProductsMap = new Map();
    const newlyAddedProducts = [];
    const newlyAddedKeys = new Set();

    existingProducts.forEach((product) => {
      const key = createUniqueKey(
        product.productId,
        product.systemId,
        product.phaseId
      );
      existingProductsMap.set(key, { ...product });
    });

    newProducts.forEach((product) => {
      const key = createUniqueKey(
        product.productId,
        product.systemId,
        product.phaseId
      );

      if (existingProductsMap.has(key)) {
        const existingProduct = existingProductsMap.get(key);
        const newQuantity =
          (parseInt(existingProduct.quantity) || 0) +
          (parseInt(product.quantity) || 0);

        const newRate = parseFloat(existingProduct.rate) || 0;
        const newAmount = (newQuantity * newRate).toFixed(2);

        const mergedProduct = {
          ...existingProduct,
          ...product,
          quantity: newQuantity,
          rate: newRate,
          amount: parseFloat(newAmount),
        };

        existingProductsMap.delete(key);
        newlyAddedProducts.push(mergedProduct);
        newlyAddedKeys.add(key);
      } else {
        const newProduct = {
          ...product,
          quantity: parseInt(product.quantity) || 0,
          rate: parseFloat(product.rate) || 0,
          amount: parseFloat(product.amount) || 0,
        };

        newlyAddedProducts.push(newProduct);
        newlyAddedKeys.add(key);
      }
    });

    const remainingExistingProducts = Array.from(existingProductsMap.values());
    return {
      products: [...newlyAddedProducts, ...remainingExistingProducts],
      newlyAddedKeys: newlyAddedKeys,
    };
  };

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(true);
      setPendingNavigation(() => blocker.proceed);
    }
  }, [blocker.state]);

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  useEffect(() => {
    const hasChanges =
      JSON.stringify(newProducts) !== JSON.stringify(initialNewProducts);
    setHasUnsavedChanges(hasChanges);
  }, [newProducts, initialNewProducts]);

  useEffect(() => {
    if (selectedSystemForFilter) {
      const selectedSystem = systems.find(
        (sys) => sys.system_id === selectedSystemForFilter.value
      );
      const filteredPhases = selectedSystem?.phases || [];

      const phaseOptions = filteredPhases.map((phase) => ({
        value: phase.phase_id,
        label: phase.phase_name,
      }));

      if (
        selectedPhaseForFilter &&
        !phaseOptions.find((p) => p.value === selectedPhaseForFilter.value)
      ) {
        setSelectedPhaseForFilter(null);
      }
    } else {
      setSelectedPhaseForFilter(null);
    }
  }, [selectedSystemForFilter, systems]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchNewProducts, selectedSystemForFilter, selectedPhaseForFilter]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getBomData();
        await getSystems();
      } catch (err) { }
    };
    if (decodedToken && jobId && bomId) {
      fetchData();
    }
  }, [decodedToken, jobId, bomId]);

  useEffect(() => {
    if (recentlyAddedProducts.size > 0) {
      const fadeTimer = setTimeout(() => {
        setFadingProducts(new Set(recentlyAddedProducts));
      }, 2000);

      const removeTimer = setTimeout(() => {
        setRecentlyAddedProducts(new Set());
        setFadingProducts(new Set());
      }, 4000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [recentlyAddedProducts]);

  const handleDiscardChanges = () => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(false);

      setHasUnsavedChanges(false);

      setTimeout(() => {
        if (pendingNavigation) {
          pendingNavigation();
          setPendingNavigation(null);
        } else if (blocker.proceed) {
          blocker.proceed();
        }
      }, 0);
    }
  };

  const handleCancelDiscard = () => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    setShowDiscardModal(false);
    setPendingNavigation(null);
  };

  const getBomData = async () => {
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}job/${jobId}/bom/${bomId}`,
        config
      );

      if (response.data.response.data) {
        setBomData(response.data.response.data.bomData);
        setBomInfo(response.data.response.data.bomInfo);
        setTotals(response.data.response.data.totals);
        setJobName(response.data.response.data.bomInfo.jobName || "");
      }
      setLoading(false);
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err);
      setLoading(false);
    }
  };

  const getSystems = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}job/${jobId}/systems-with-phases`,
        config
      );

      const systemsData = response.data.response.data.systems || [];
      setSystems(systemsData);

      const allPhases = systemsData.flatMap((system) => system.phases || []);
      setPhases(allPhases);

      const systemOptions = systemsData.map((system) => ({
        value: system.system_id,
        label: system.system_name,
      }));
      setOptionsSystem(systemOptions);
    } catch (err) {
      handleError(err);
    }
  };

  const handleError = (err, alertName) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )
          ? "admin"
          : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: alertName || "danger",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const handleDownloadPDF = () => {
    if (!printContentRef.current) return;

    const printContent = printContentRef.current.innerHTML;

    const pdfContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${bomInfo.bomNumber || "BOM-Report"}</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              color: #000;
              margin: 0;
              padding: 0;
            }
            
            .page-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 2px solid #0056b3;
              padding-bottom: 8px;
              margin-bottom: 10px;
            }
            
            .page-footer {
              text-align: center;
              border-top: 2px solid #3a57e8;
              padding-top: 6px;
              font-size: 7pt;
              font-weight: 600;
              color: #333;
              background: white;
              margin-top: 20px;
            }
            
            .printLogo {
              height: auto;
              width: 70px;
            }
            
            .printTitle {
              text-align: right;
            }
            
            .printMainTitle {
              margin: 0;
              font-size: 13pt;
              color: #3a57e8;
              font-weight: 600;
              letter-spacing: 0.5px;
            }
            
            .printBomNumber {
              margin: 3px 0 0 0;
              font-size: 7.5pt;
            }
            
            .printBold {
              font-weight: bold;
            }
            
            .printContent {
              padding-bottom: 20mm;
            }
            
            .printMetadata {
              border: 1px solid #ddd;
              padding: 8px 10px;
              margin-bottom: 10px;
              background-color: #f5f5f5;
            }

            .printMetadataRow {
              display: flex;
              justify-content: space-between;
              margin-bottom: 4px;
            }

            .printMetadataRow:last-child {
              margin-bottom: 0;
            }

            .printMetadataItem {
              flex: 1;
              font-size: 8pt;
              display: flex;
            }

            .printMetadataLabel {
              font-weight: bold;
              min-width: 120px;
              display: inline-block;
            }
            
            .printHeading {
              margin: 10px 0 8px 0;
              font-size: 11pt;
              font-weight: 600;
            }
            
            .printSystem {
              margin-bottom: 12px;
            }
            
            .printSystemHeader {
              background-color: #5a6268 !important;
              color: white !important;
              padding: 6px 10px;
              margin: 0 0 6px 0;
              font-size: 8pt;
              font-weight: bold;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            
            .printTable {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 8px;
              font-size: 6.5pt;
            }
            
            .printTable thead th {
              background-color: #3a57e8 !important;
              color: white !important;
              text-transform: uppercase;
              font-weight: 600;
              font-size: 6pt;
              padding: 5px 4px;
              border: 1px solid #3a57e8;
              text-align: left;
              white-space: nowrap;
            }
            
            .printTable tbody td {
              padding: 4px 3px;
              font-size: 6.5pt;
              border: 1px solid #dee2e6;
            }
            
            .printTable tbody tr {
              background-color: #ffffff;
            }
            
            .printTable tbody tr:nth-child(even) {
              background-color: #f8f9fa;
            }
            
            .printAvailable {
              color: #28a745 !important;
              font-weight: bold;
            }
            
            .printShortage {
              color: #dc3545 !important;
              font-weight: bold;
            }
            
            .printOrder {
              background-color: #fff3cd !important;
              font-weight: bold;
            }
            
            .printSignatureSection {
              display: flex;
              justify-content: space-between;
              margin-top: 35px;
              margin-bottom: 15px;
              gap: 30px;
            }
            
            .printSignatureBox {
              flex: 1;
            }
            
            .printSignatureTitle {
              font-weight: bold;
              font-size: 9pt;
              margin-bottom: 10px;
            }
            
            .printSignatureLine {
              margin-bottom: 12px;
            }
            
            .printSignatureLine span {
              display: block;
              font-size: 8pt;
              margin-bottom: 4px;
            }
            
            .printLine {
              border-bottom: 1px solid #333;
              width: 55%;
              margin-top: 2px;
            }
            
            .printFooterNotes {
              margin-top: 10px;
              padding-top: 8px;
              border-top: 1px solid #ddd;
              font-size: 6.5pt;
              color: #666;
            }
            
            .printFooterNotes p {
              margin-bottom: 3px;
            }
          </style>
        </head>
        <body>
          <div class="printContent">
            ${printContent}
          </div>
          <div class="page-footer">
            <p>
              Coyote Cabling, Inc. • 123 Copper Way, Dallas, TX 75201 •
              procurement@coyotecabling.com
            </p>
          </div>
        </body>
      </html>
    `;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = pdfContent;
    document.body.appendChild(tempDiv);

    const opt = {
      margin: [15, 12, 15, 12],
      filename: `${bomInfo.bomNumber || "BOM-Report"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "landscape",
      },
    };

    html2pdf()
      .set(opt)
      .from(tempDiv)
      .save()
      .then(() => {
        document.body.removeChild(tempDiv);
      });
  };

  const handlePrint = () => {
    if (!printContentRef.current) return;

    const printFrame = document.createElement("iframe");
    printFrame.style.position = "fixed";
    printFrame.style.right = "0";
    printFrame.style.bottom = "0";
    printFrame.style.width = "0";
    printFrame.style.height = "0";
    printFrame.style.border = "0";
    document.body.appendChild(printFrame);

    const printContent = printContentRef.current.innerHTML;
    const printDocument = printFrame.contentWindow.document;

    printDocument.open();
    printDocument.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${bomInfo.bomNumber || "BOM-Report"}</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: Arial, sans-serif;
              font-size: 9pt;
              color: #000;
              background: #fff;
              margin: 0;
              padding: 0;
            }
            
            @page {
              size: A4 landscape;
              margin: 15mm 12mm 15mm 12mm;
            }
            
            @media print {
              body {
                print-color-adjust: exact !important;
                -webkit-print-color-adjust: exact !important;
              }
              
              .printSystemHeader,
              .printTable thead th,
              .printAvailable,
              .printShortage,
              .printOrder {
                print-color-adjust: exact !important;
                -webkit-print-color-adjust: exact !important;
              }
              
              .page-footer {
                position: fixed;
                bottom: 0mm;
                left: 12mm;
                right: 12mm;
                text-align: center;
                border-top: 2px solid #3a57e8;
                padding-top: 6px;
                font-size: 7pt;
                font-weight: 600;
                color: #333;
                background: white;
                z-index: 9999;
              }
              
              .printContent {
                padding-bottom: 20mm;
              }
            }
            
            .page-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 2px solid #0056b3;
              padding-bottom: 8px;
              margin-bottom: 10px;
            }
            
            .page-footer {
              position: fixed;
              bottom: 0mm;
              left: 12mm;
              right: 12mm;
              text-align: center;
              border-top: 2px solid #3a57e8;
              padding-top: 6px;
              font-size: 7pt;
              font-weight: 600;
              color: #333;
              background: white;
            }
            
            .printLogo {
              height: auto;
              width: 70px;
            }
            
            .printTitle {
              text-align: right;
            }
            
            .printMainTitle {
              margin: 0;
              font-size: 13pt;
              color: #3a57e8;
              font-weight: 600;
              letter-spacing: 0.5px;
            }
            
            .printBomNumber {
              margin: 3px 0 0 0;
              font-size: 7.5pt;
            }
            
            .printBold {
              font-weight: bold;
            }
            
            .printContent {
              padding-bottom: 20mm;
            }
            
            .printMetadata {
              border: 1px solid #ddd;
              padding: 8px 10px;
              margin-bottom: 10px;
              background-color: #f5f5f5;
              page-break-inside: avoid;
            }

            .printMetadataRow {
              display: flex;
              justify-content: space-between;
              margin-bottom: 4px;
            }

            .printMetadataRow:last-child {
              margin-bottom: 0;
            }

            .printMetadataItem {
              flex: 1;
              font-size: 8pt;
              display: flex;
            }

            .printMetadataLabel {
              font-weight: bold;
              min-width: 120px;
              display: inline-block;
            }
            
            .printHeading {
              margin: 10px 0 8px 0;
              font-size: 11pt;
              font-weight: 600;
              page-break-after: avoid;
            }
            
            .printSystem {
              margin-bottom: 12px;
            }
            
            .printSystemHeader {
              background-color: #5a6268;
              color: white;
              padding: 6px 10px;
              margin: 0 0 6px 0;
              font-size: 8pt;
              font-weight: bold;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              page-break-after: avoid;
            }
            
            .printTable {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 8px;
              font-size: 6.5pt;
              page-break-inside: auto;
            }
            
            .printTable thead th {
              background-color: #3a57e8;
              color: white;
              text-transform: uppercase;
              font-weight: 600;
              font-size: 6pt;
              padding: 5px 4px;
              border: 1px solid #3a57e8;
              text-align: left;
              white-space: nowrap;
            }
            
            .printTable tbody td {
              padding: 4px 3px;
              font-size: 6.5pt;
              border: 1px solid #dee2e6;
            }
            
            .printTable tbody tr {
              background-color: #ffffff;
              page-break-inside: avoid;
              page-break-after: auto;
            }
            
            .printTable tbody tr:nth-child(even) {
              background-color: #f8f9fa;
            }
            
            .printAvailable {
              color: #28a745;
              font-weight: bold;
            }
            
            .printShortage {
              color: #dc3545;
              font-weight: bold;
            }
            
            .printOrder {
              background-color: #fff3cd;
              font-weight: bold;
            }
            
            .printSignatureSection {
              display: flex;
              justify-content: space-between;
              margin-top: 35px;
              margin-bottom: 15px;
              gap: 30px;
              page-break-inside: avoid;
            }
            
            .printSignatureBox {
              flex: 1;
            }
            
            .printSignatureTitle {
              font-weight: bold;
              font-size: 9pt;
              margin-bottom: 10px;
            }
            
            .printSignatureLine {
              margin-bottom: 12px;
            }
            
            .printSignatureLine span {
              display: block;
              font-size: 8pt;
              margin-bottom: 4px;
            }
            
            .printLine {
              border-bottom: 1px solid #333;
              width: 55%;
              margin-top: 2px;
            }
            
            .printFooterNotes {
              margin-top: 10px;
              padding-top: 8px;
              border-top: 1px solid #ddd;
              font-size: 6.5pt;
              color: #666;
              page-break-inside: avoid;
            }
            
            .printFooterNotes p {
              margin-bottom: 3px;
            }
          </style>
        </head>
        <body>
          <div class="printContent">
            ${printContent}
          </div>
          <div class="page-footer">
            <p>
              Coyote Cabling, Inc. • 123 Copper Way, Dallas, TX 75201 •
              procurement@coyotecabling.com
            </p>
          </div>
        </body>
      </html>
    `);

    printDocument.close();

    setTimeout(() => {
      try {
        printFrame.contentWindow.focus();
        printFrame.contentWindow.print();

        setTimeout(() => {
          document.body.removeChild(printFrame);
        }, 1000);
      } catch (error) {
        document.body.removeChild(printFrame);
      }
    }, 500);
  };

  const togglePopoverItem = (itemKey) => {
    setShowPopoverItem(showPopoverItem === itemKey ? null : itemKey);
  };

  const handleUpdateProductQty = async (
    productId,
    systemId,
    phaseId,
    newQty
  ) => {
    if (!isEditingAllowed()) {
      setAlert({
        message: "Editing is not allowed for this BOM's current status",
        type: "warning",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
      return false;
    }

    const updatingKey = `${productId}-${systemId}-${phaseId}`;
    try {
      setIsUpdatingQty(updatingKey);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.put(
        `${url.backendURL}job/${jobId}/bom/${bomId}/product/${productId}/system/${systemId}/phase/${phaseId}/quantity`,
        { quantity: newQty },
        config
      );

      if (response.data.response?.data) {
        const updatedData = response.data.response.data;
        setBomData(updatedData.bomData);
        setBomInfo(updatedData.bomInfo);
        setTotals(updatedData.totals);
      } else {
        await getBomData();
      }
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      const hasAvailabilityUpdate =
        response.data.response?.availabilityUpdated || false;
      let successMessage =
        response.data.message || "BOM product quantity updated successfully";
      if (hasAvailabilityUpdate) {
        successMessage +=
          ". Inventory availability has been refreshed to reflect the latest stock levels";
      }

      setAlert({
        message: successMessage,
        type: "success",
        show: true,
        alertFor: "job-bom-edit",
      });

      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);

      setEditingProduct(null);
      setEditingQty("");
      setIsUpdatingQty(null);
      return true;
    } catch (err) {
      handleError(err);
      setIsUpdatingQty(null);
      return false;
    }
  };

  const handleDeleteProductItem = async (
    systemName,
    productId,
    systemId,
    phaseId
  ) => {
    if (!isEditingAllowed()) {
      setAlert({
        message: "Deleting is not allowed for this BOM's current status",
        type: "warning",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
      return false;
    }

    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.delete(
        `${url.backendURL}job/${jobId}/bom/${bomId}/product/${productId}/system/${systemId}/phase/${phaseId}`,
        config
      );

      if (response.data.response?.data) {
        const updatedData = response.data.response.data;
        setBomData(updatedData.bomData);
        setBomInfo(updatedData.bomInfo);
        setTotals(updatedData.totals);
      } else {
        setBomData((prevData) => ({
          ...prevData,
          [systemName]: prevData[systemName].filter(
            (item) => item.id !== productId
          ),
        }));
        await getBomData();
      }

      const hasAvailabilityUpdate =
        response.data.response?.availabilityUpdated || false;
      let successMessage = response.data.message;
      if (hasAvailabilityUpdate) {
        successMessage +=
          ". Inventory availability has been refreshed to reflect the latest stock levels";
      }

      setAlert({
        message: successMessage,
        type: "success",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);

      return true;
    } catch (err) {
      handleError(err);
      return false;
    }
  };

  const handleSystemPhaseChange = (uniqueKey, updates) => {
    const oldProduct = newProducts.find(
      (p) => createUniqueKey(p.productId, p.systemId, p.phaseId) === uniqueKey
    );

    if (!oldProduct) return;

    const newProductKey = createUniqueKey(
      oldProduct.productId,
      updates.systemId !== undefined ? updates.systemId : oldProduct.systemId,
      updates.phaseId !== undefined ? updates.phaseId : oldProduct.phaseId
    );

    const existingProduct = newProducts.find(
      (p) =>
        createUniqueKey(p.productId, p.systemId, p.phaseId) === newProductKey &&
        newProductKey !== uniqueKey
    );

    if (existingProduct) {
      setIsMerging(true);

      setTimeout(() => {
        const updatedProducts = newProducts
          .map((p) => {
            const pKey = createUniqueKey(p.productId, p.systemId, p.phaseId);

            if (pKey === newProductKey) {
              const newQuantity =
                (parseInt(p.quantity) || 0) +
                (parseInt(oldProduct.quantity) || 0);
              const newAmount = (
                newQuantity * (parseFloat(p.rate) || 0)
              ).toFixed(2);
              return {
                ...p,
                quantity: newQuantity,
                amount: parseFloat(newAmount),
              };
            }

            if (pKey === uniqueKey) {
              return null;
            }

            return p;
          })
          .filter(Boolean);

        setNewProducts(updatedProducts);
        setRecentlyAddedProducts(new Set([newProductKey]));
        setIsMerging(false);
      }, 500);
    } else {
      const updatedProducts = newProducts.map((p) =>
        createUniqueKey(p.productId, p.systemId, p.phaseId) === uniqueKey
          ? { ...p, ...updates }
          : p
      );
      setNewProducts(updatedProducts);
    }
  };

  const handleAddProducts = (addedProducts) => {
    setIsMerging(true);

    setTimeout(() => {
      const { products: mergedProducts, newlyAddedKeys } = mergeProducts(
        newProducts,
        addedProducts
      );

      setNewProducts(mergedProducts);
      setRecentlyAddedProducts(newlyAddedKeys);
      setIsMerging(false);
    }, 500);
  };

  const handleCloseProductsView = () => {
    setProductsViewModel(false);
  };

  const fetchProductSuggestions = async (
    inputValue,
    selectedProductIds = [],
    keyCol,
    directionCol,
    limit,
    offset
  ) => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          product: inputValue,
          searchKey: keyCol,
          searchDirection: directionCol,
          limit: limit,
          offset: offset,
        },
      };

      const response = await axios.get(`${url.backendURL}job/products`, config);
      const products = response.data.response.data;
      const pagination = response.data.response.pagination;

      const productsData = {
        products: products
          .filter(
            (product) =>
              !selectedProductIds.includes(product.product_id) ||
              !selectedProductIds.includes(product.productId)
          )
          .map((product) => ({
            productId: product.product_id,
            productName: product.product_name,
            rate: product.product_cost,
            quantity: 1,
            amount: 1 * product.product_cost,
            model: product.product_model,
            manufacturerId: product.manufacturer_id,
            manufacturerName: product.manufacturer_name,
            sku: product.sku,
            description: product.product_description,
            systemId: activeSystemId,
            phaseId: activeSystemId ? activePhaseId : null,
          })),
        total: pagination.total,
        offset: pagination.offset,
        nextOffset: pagination.nextOffset,
      };

      return productsData;
    } catch (error) {
      if (
        error.response?.data?.error === "jwt expired" ||
        error.response?.data?.error === "Unauthorized. User not found"
      ) {
        localStorage.removeItem("coyote-token");
        navigate(
          `/${decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
          }/auth/sign-in`,
          {
            state: { status: "expired" },
          }
        );
      }
      return {
        products: [],
        total: -1,
        offset: 0,
        nextOffset: null,
      };
    }
  };

  const handleUpdate = async () => {
    if (!isEditingAllowed()) {
      setAlert({
        message: "Updating is not allowed for this BOM's current status",
        type: "warning",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
      return;
    }

    if (isSubmitting) return;
    const errors = validateNewProducts();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      if (alertRef.current) {
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setAlert({
        message: "Please fill in all required fields correctly",
        type: "danger",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
      return;
    }

    try {
      setIsSubmitting(true);
      setValidationErrors({});
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const productsToAdd = newProducts.map((item) => ({
        productId: item.productId,
        systemId: item.systemId,
        phaseId: item.phaseId,
        quantityRequired: item.quantity,
        unitCost: item.rate,
        rate: item.rate,
        amount: item.amount,
        quantity: item.quantity,
        productTotalCost: item.amount,
      }));

      const response = await axios.put(
        `${url.backendURL}job/${jobId}/bom/${bomId}`,
        { products: productsToAdd },
        config
      );

      if (response.data.response?.data) {
        const updatedData = response.data.response.data;
        setBomData(updatedData.bomData);
        setBomInfo(updatedData.bomInfo);
        setTotals(updatedData.totals);
      } else {
        await getBomData();
      }

      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      const hasAvailabilityUpdate =
        response.data.response?.availabilityUpdated || false;
      let successMessage = response.data.message;
      if (hasAvailabilityUpdate) {
        successMessage +=
          ". Inventory availability has been refreshed to reflect the latest stock levels";
      }

      setAlert({
        message: successMessage,
        type: "success",
        show: true,
        alertFor: "job-bom-edit",
      });
      setHasUnsavedChanges(false);
      setNewProducts([]);
      setInitialNewProducts([]);

      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 2000);
    } catch (err) {
      handleError(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const hasError = (uniqueKey, fieldName) => {
    return validationErrors[uniqueKey]?.[fieldName];
  };

  const getErrorMessage = (uniqueKey, fieldName) => {
    return validationErrors[uniqueKey]?.[fieldName];
  };

  const handleUpdateAvailability = async () => {
    if (!isEditingAllowed()) {
      setAlert({
        message:
          "Checking availability is not allowed for this BOM's current status",
        type: "warning",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
      return;
    }

    try {
      setIsUpdateAvailabilityEnabled(false);
      setIsSubmittingAvailability(true);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.put(
        `${url.backendURL}job/${jobId}/bom/${bomId}/update-availability`,
        {},
        config
      );

      await getBomData();
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      setAlert({
        message:
          response.data.message ||
          "Latest stock availability has been checked and saved to this BOM",
        type: "success",
        show: true,
        alertFor: "job-bom-edit",
      });

      setIsUpdateAvailabilityEnabled(false);

      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
    } catch (err) {
      handleError(err);
    } finally {
      setIsSubmittingAvailability(false);
      setIsUpdateAvailabilityEnabled(false);
    }
  };

  const handleReset = () => {
    setNewProducts([]);
    setInitialNewProducts([]);
    setSearchNewProducts("");
    setSelectedSystemForFilter(null);
    setSelectedPhaseForFilter(null);
    setCurrentPage(1);
    setHasUnsavedChanges(false);
    setRecentlyAddedProducts(new Set());
    setFadingProducts(new Set());
    setValidationErrors({});
  };

  const [highlightedQuantities, setHighlightedQuantities] = useState(new Set());

  const handleOpenCreatePRModal = () => {
    if (!isEditingAllowed()) {
      setAlert({
        message: "Creating PR is not allowed for this BOM's current status",
        type: "warning",
        show: true,
        alertFor: "job-bom-edit",
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 3000);
      return;
    }
    setShowCreatePRModal(true);
  };

  const handleConfirmCreatePR = async () => {
    try {
      setIsCreatingPR(true);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.post(
        `${url.backendURL}job/${jobId}/bom/${bomId}/create-pr`,
        {},
        config
      );
      setShowCreatePRModal(false);
      await getBomData();

      const productRequestId =
        response?.data?.response?.data?.productRequestId || null;

      const hasAnyPRPermission =
        productRequestHasViewPermission ||
        productRequestHasDeletePermission ||
        productRequestHasUpdatePermission ||
        productRequestHasStatusPermission;

      const successMessage =
        response?.data?.message ||
        "Product Request created successfully. BOM status has been updated to PR-Created.";

      if (hasAnyPRPermission && productRequestId) {
        navigate(`/dashboard/app/product-request-list`, {
          state: {
            productRequestId: productRequestId,
            showSuccessMessage: true,
            successMessage,
          },
        });
      } else {
        setAlert({
          message: "Product request created successfully",
          type: "success",
          show: true,
          alertFor: "job-bom-edit",
        });
        setTimeout(() => {
          setAlert({ show: false, alertFor: "", message: "", type: "" });
        }, 3000);
      }
    } catch (err) {
      setShowCreatePRModal(false);
      handleError(err, "warning");
    } finally {
      setIsCreatingPR(false);
    }
  };

  const handleCancelCreatePR = () => {
    setShowCreatePRModal(false);
  };

  const handleCreatePR = async () => {
    handleOpenCreatePRModal();
  };

  const getFilteredPhasesForSystem = (systemId) => {
    if (!systemId) return [];
    const selectedSystem = systems.find((sys) => sys.system_id === systemId);
    if (!selectedSystem || !selectedSystem.phases) return [];
    return selectedSystem.phases.map((phase) => ({
      value: phase.phase_id,
      label: phase.phase_name,
    }));
  };

  const handleSortNewProducts = (columnKey) => {
    let direction = "asc";
    if (
      sortConfigNewProducts.key === columnKey &&
      sortConfigNewProducts.direction === "asc"
    ) {
      direction = "desc";
    } else if (
      sortConfigNewProducts.key === columnKey &&
      sortConfigNewProducts.direction === "desc"
    ) {
      direction = "asc";
    }
    setSortConfigNewProducts({ key: columnKey, direction });

    setNewProducts((prev) =>
      [...prev].sort((a, b) => {
        let aValue = a[columnKey]?.toString().toLowerCase();
        let bValue = b[columnKey]?.toString().toLowerCase();

        if (aValue < bValue) return direction === "asc" ? -1 : 1;
        if (aValue > bValue) return direction === "asc" ? 1 : -1;
        return 0;
      })
    );
  };

  const getFilteredNewProducts = () => {
    if (
      !searchNewProducts.trim() &&
      !selectedSystemForFilter &&
      !selectedPhaseForFilter
    ) {
      return newProducts || [];
    }

    const normalize = (str) => str?.toLowerCase().replace(/[+-]/g, "") || "";
    const searchTerm = normalize(searchNewProducts);
    const hasSearchTerm = searchNewProducts.trim();
    const hasSystemId = selectedSystemForFilter;
    const hasPhaseId = selectedPhaseForFilter;

    return (newProducts || []).filter((item) => {
      const system =
        systems.find((sys) => sys.system_id === item.systemId) || {};
      const phase = phases.find((ph) => ph.phase_id === item.phaseId) || {};

      const searchableFields = [
        item.productName,
        item.manufacturerName,
        item.model,
        item.description,
        item.sku,
        system.system_name,
        phase.phase_name,
      ].filter(Boolean);

      const combinedText = normalize(searchableFields.join(" ").toLowerCase());
      const tokens = searchTerm.trim().split(/\s+/);
      const searchMatch = tokens.every((token) => combinedText.includes(token));

      const systemIdMatch =
        item.systemId &&
        item.systemId.toString() === selectedSystemForFilter?.value?.toString();

      const phaseIdMatch =
        item.phaseId &&
        item.phaseId.toString() === selectedPhaseForFilter?.value?.toString();

      if (hasSearchTerm && hasSystemId && hasPhaseId) {
        return searchMatch && systemIdMatch && phaseIdMatch;
      }
      if (hasSearchTerm && hasSystemId && !hasPhaseId) {
        return searchMatch && systemIdMatch;
      }
      if (hasSearchTerm && !hasSystemId && hasPhaseId) {
        return searchMatch && phaseIdMatch;
      }
      if (!hasSearchTerm && hasSystemId && hasPhaseId) {
        return systemIdMatch && phaseIdMatch;
      }
      if (hasSearchTerm && !hasSystemId && !hasPhaseId) {
        return searchMatch;
      }
      if (!hasSearchTerm && hasSystemId && !hasPhaseId) {
        return systemIdMatch;
      }
      if (!hasSearchTerm && !hasSystemId && hasPhaseId) {
        return phaseIdMatch;
      }
      return false;
    });
  };

  const getPaginatedNewProducts = () => {
    const filteredProducts = getFilteredNewProducts();
    const itemsToShow = currentPage * itemsPerPage;
    return filteredProducts.slice(0, itemsToShow);
  };

  const hasMoreNewProducts = () => {
    const filteredProducts = getFilteredNewProducts();
    const itemsToShow = currentPage * itemsPerPage;
    return filteredProducts.length > itemsToShow;
  };

  const loadMoreNewProducts = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "available":
        return "statusAvailable";
      case "shortage":
        return "statusShortage";
      case "order":
        return "qtyOrder";
      default:
        return "";
    }
  };

  const getPrintStatusClass = (status) => {
    switch (status) {
      case "available":
        return "printAvailable";
      case "shortage":
        return "printShortage";
      case "order":
        return "printOrder";
      default:
        return "";
    }
  };

  const renderSystemTable = (systemName, systemData) => (
    <div key={systemName} className="systemSection">
      <div className="systemHeader">System: {systemName.toUpperCase()}</div>
      <div className="tableWrapper">
        <table className="dataTable">
          <thead>
            <tr>
              <th>Phase</th>
              <th>Product (Model/SKU)</th>
              <th>Unit</th>
              <th>Make</th>
              <th>Qty Required</th>
              <th>Qty In Stock</th>
              <th>Qty Allocated*</th>
              <th>Net Available</th>
              <th>QTY TO ORDER</th>
              <th>Location</th>
              <th className="noPrint">Action</th>
            </tr>
          </thead>
          <tbody>
            {systemData.map((item, index) => {
              const uniqueKey = `${item.productId}-${item.systemId}-${item.phaseId}`;
              const isEditing = editingProduct === uniqueKey;
              const isUpdatingThisRow = isUpdatingQty === uniqueKey;

              return (
                <tr key={index}>
                  <td>{item.phase}</td>
                  <td>{item.product}</td>
                  <td>{item.unit}</td>
                  <td>{item.manufacturer}</td>
                  <td className="noPrint">
                    {isEditing &&
                      isEditingAllowed() &&
                      (hasBomEditPermission ||
                        decodedToken?.roles?.some(
                          (role) => role.role_type === roleTypes.SUPER_ADMIN
                        )) ? (
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          border: "none !important",
                        }}
                      >
                        <Form.Control
                          type="text"
                          min="1"
                          value={editingQty}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setEditingQty("");
                              return;
                            }

                            if (!/^\d+$/.test(value)) {
                              return;
                            }

                            const parsedValue = parseInt(value, 10);
                            if (parsedValue > 99999) {
                              return;
                            }

                            if (!isNaN(parsedValue) && parsedValue >= 0) {
                              setEditingQty(value);
                            }
                          }}
                          onBlur={async () => {
                            if (
                              editingQty &&
                              parseInt(editingQty) > 0 &&
                              parseInt(editingQty) !== item.qtyRequired
                            ) {
                              await handleUpdateProductQty(
                                item.productId,
                                item.systemId,
                                item.phaseId,
                                parseInt(editingQty)
                              );
                            } else {
                              setEditingProduct(null);
                              setEditingQty("");
                            }
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              editingQty &&
                              parseInt(editingQty) > 0 &&
                              parseInt(editingQty) !== item.qtyRequired
                            ) {
                              e.target.blur();
                            }
                            if (e.key === "Escape") {
                              setEditingProduct(null);
                              setEditingQty("");
                            }
                          }}
                          style={{
                            width: "80px",
                            fontSize: "0.9rem",
                            border: "none !important",
                            paddingRight: isUpdatingThisRow ? "30px" : "12px",
                          }}
                          autoFocus
                          disabled={isUpdatingThisRow}
                        />
                        {isUpdatingThisRow && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0%",
                              border: "none !important",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <RotatingLines
                              strokeWidth="5"
                              animationDuration="0.75"
                              width="20"
                              strokeColor="#b2b4b9"
                              color="#b2b4b9"
                              visible={true}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        onDoubleClick={() => {
                          if (
                            isEditingAllowed() &&
                            (hasBomEditPermission ||
                              decodedToken?.roles?.some(
                                (role) =>
                                  role.role_type === roleTypes.SUPER_ADMIN
                              ))
                          ) {
                            setEditingProduct(
                              `${item.productId}-${item.systemId}-${item.phaseId}`
                            );
                            setEditingQty(item.qtyRequired.toString());
                          }
                        }}
                        className="d-flex align-items-center justify-content-between gap-2"
                        style={{
                          gap: "8px",
                          border: "none !important",
                          position: "relative",
                        }}
                      >
                        {isUpdatingThisRow && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "8px",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              zIndex: 10,
                            }}
                          >
                            <RotatingLines
                              strokeWidth="5"
                              animationDuration="0.75"
                              width="20"
                              strokeColor="#b2b4b9"
                              color="#b2b4b9"
                              visible={true}
                            />
                          </div>
                        )}
                        <span
                          style={{
                            cursor: isEditingAllowed() ? "pointer" : "default",
                            userSelect: "none",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            border: "none !important",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={(e) => {
                            if (isEditingAllowed()) {
                              e.target.style.backgroundColor = "#f0f0f0";
                            }
                          }}
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "transparent")
                          }
                          title={
                            isEditingAllowed()
                              ? "Double click to edit"
                              : "Editing not allowed"
                          }
                        >
                          {item.qtyRequired}
                        </span>
                        {isEditingAllowed() &&
                          (hasBomEditPermission ||
                            decodedToken?.roles?.some(
                              (role) => role.role_type === roleTypes.SUPER_ADMIN
                            )) && (
                            <Button
                              size="sm"
                              variant="link"
                              className="p-0 text-yellow"
                              onClick={() => {
                                setEditingProduct(
                                  `${item.productId}-${item.systemId}-${item.phaseId}`
                                );
                                setEditingQty(item.qtyRequired.toString());
                              }}
                              title="Edit Quantity"
                              style={{
                                color: "#6c757d",
                                border: "none !important",
                              }}
                            >
                              <Edit
                                size={14}
                                style={{ border: "none !important" }}
                              />
                            </Button>
                          )}
                      </div>
                    )}
                  </td>

                  <td>{item.qtyInStock}</td>
                  <td>{item.qtyAllocated}</td>
                  <td className={getStatusClass(item.status)}>
                    {item.netAvailable}
                  </td>
                  <td className={item.qtyToOrder > 0 ? "qtyOrder" : ""}>
                    {item.qtyToOrder}
                  </td>
                  <td>
                    {item.location && typeof item.location === 'string'
                      ? item.location
                        .split(",")
                        .map((loc) => loc.trim())
                        .filter(Boolean)
                        .map((loc, index, arr) => (
                          <React.Fragment key={index}>
                            {loc}
                            {index !== arr.length - 1 ? "," : ""}
                            <br />
                          </React.Fragment>
                        ))
                      : item.location || ""}
                  </td>
                  <td className="noPrint" style={{ textAlign: "center" }}>
                    {isEditingAllowed() &&
                      (hasBomEditPermission ||
                        decodedToken?.roles?.some(
                          (role) => role.role_type === roleTypes.SUPER_ADMIN
                        )) && (
                        <OverlayTrigger
                          trigger="click"
                          show={
                            showPopoverItem ===
                            `delete-${systemName}-${item.id}`
                          }
                          onToggle={() =>
                            togglePopoverItem(`delete-${systemName}-${item.id}`)
                          }
                          placement="left"
                          overlay={
                            <Popover
                              id={`popover-delete-${systemName}-${item.id}`}
                            >
                              <Popover.Header as="h2">
                                <strong>Delete</strong>{" "}
                                <span>{`(${item.product})`}</span>?
                              </Popover.Header>
                              <Popover.Body>
                                Once deleted, this action cannot be undone.
                                <div className="d-flex justify-content-end mt-2">
                                  <Button
                                    size="sm"
                                    variant="danger"
                                    className="me-2"
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      if (deleteIsSubmit) {
                                        setDeleteIsSubmit(false);
                                        const success =
                                          await handleDeleteProductItem(
                                            systemName,
                                            item.productId,
                                            item.systemId,
                                            item.phaseId
                                          );
                                        if (success) {
                                          togglePopoverItem(
                                            `delete-${systemName}-${item.id}`
                                          );
                                        }
                                        setDeleteIsSubmit(true);
                                      }
                                    }}
                                  >
                                    Delete
                                  </Button>
                                  <Button
                                    size="sm"
                                    className="text-black bg-white"
                                    variant="secondary"
                                    onClick={(e) => {
                                      togglePopoverItem(
                                        `delete-${systemName}-${item.id}`
                                      );
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <Button
                            className="btn btn-sm btn-icon btn-danger"
                            variant="btn btn-danger"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() =>
                              togglePopoverItem(
                                `delete-${systemName}-${item.id}`
                              )
                            }
                          >
                            <span className="btn-inner">
                              <svg
                                width="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                              >
                                <path
                                  d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M20.708 6.23975H3.75"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </span>
                          </Button>
                        </OverlayTrigger>
                      )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
  const renderPrintSystemTable = (systemName, systemData) => {
    return `
      <div class="printSystem">
        <div class="printSystemHeader">SYSTEM: ${systemName.toUpperCase()}</div>       
        <table class="printTable">         
        <thead>           <tr>             <th>Phase</th>             
        <th>Product (Model/SKU)</th>            
         <th>Unit</th>             <th>Make</th>            
          <th>Qty Required</th>            
           <th>Qty In Stock</th>            
            <th>Qty Allocated*</th>             
            <th>Net Available</th>             
            <th>Qty To Order</th>             
            <th>Location</th>           </tr>         
            </thead>         <tbody>           
            ${systemData
        .map((item) => {
          const statusClass = getPrintStatusClass(item.status);
          const orderClass = item.qtyToOrder > 0 ? "printOrder" : "";
          return `<tr>
            <td>${item.phase || ""}</td>
            <td>${item.product || ""}</td>
            <td>${item.unit || ""}</td>
            <td>${item.manufacturer || ""}</td>
            <td>${item.qtyRequired || 0}</td>
            <td>${item.qtyInStock || 0}</td>
            <td>${item.qtyAllocated || 0}</td>
            <td class="${statusClass}">${item.netAvailable || 0}</td>
            <td class="${orderClass}">${item.qtyToOrder || 0}</td>
            <td>${item.location && typeof item.location === 'string'
              ? item.location
                .split(",")
                .map((loc) => loc.trim())
                .filter(Boolean)
                .map((loc, index, arr) => {
                  return `${loc}${index !== arr.length - 1 ? "," : ""}`;
                })
                .join("<br/>")
              : item.location || ""
            }</td>
          </tr>`;
        })
        .join("")}         </tbody>       </table>     </div>`;
  };
  if (loading) {
    return (
      <div className="loadingCard">
        <FadeLoaderComponent />
      </div>
    );
  }
  return (
    <>
      <style>
        {`
      .bg-recently-added {
        background-color: #90EE90 !important;
        animation: pulseGreen 1s ease-in-out;
      }
      
      .bg-fading {
        background-color: #fff8dc !important;
        transition: background-color 2s ease;
      }
      
      @keyframes pulseGreen {
        0% {
          background-color: #90EE90;
        }
        50% {
          background-color: #76d776;
        }
        100% {
          background-color: #90EE90;
        }
      }
      
      .quantity-cell-highlight {
        background-color: #fffacd !important;
      }

      .quantity-cell-highlight {
        border: 2px solid #ffd700 !important;
        animation: yellowBorderPulse 0.5s ease-in-out;
        transition: border 5s ease-out;
      }
      
      @keyframes yellowBorderPulse {
        0% {
          border-color: #ffd700;
          box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
        }
        50% {
          border-color: #ffed4e;
          box-shadow: 0 0 20px rgba(255, 215, 0, 0.8);
        }
        100% {
          border-color: #ffd700;
          box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
        }
      }
    `}
      </style>

      <Modal
        show={showCreatePRModal}
        onHide={handleCancelCreatePR}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header className="custom-modal-header d-flex  items-center relative">
          <Modal.Title>Create Purchase Request</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelCreatePR}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className="px-4 pt-4">
          <p
            className="text-muted mb-4 px-2"
            style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
          >
            This will submit a Purchase Request and set this BOM status to{" "}
            <strong style={{ color: "#3a57e8" }}>PR-Created</strong>. Once
            created, the purchase request will be ready for processing.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            className="px-4 py-2"
            variant="btn btn-primary"
            onClick={handleConfirmCreatePR}
            disabled={isCreatingPR}
          >
            {isCreatingPR ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </Button>
          <Button
            variant="btn btn-danger"
            onClick={handleCancelCreatePR}
            disabled={isCreatingPR}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Discard Changes Modal */}
      <Modal
        show={showDiscardModal}
        onHide={handleCancelDiscard}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
          <Modal.Title>Unsaved Changes</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelDiscard}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className="text-center px-4 pt-2">
          <p
            className="text-muted mb-4 px-2"
            style={{ fontSize: "1rem", lineHeight: "1.5" }}
          >
            You have unsaved changes to new products. Do you want to discard
            these changes?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            type="button"
            className="btn btn-white me-4"
            variant="btn btn-white"
            onClick={handleDiscardChanges}
            style={{
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
              borderColor: "#6c757d",
              color: "#6c757d",
            }}
          >
            Discard
          </Button>
          <Button
            className="px-4 py-2"
            style={{
              backgroundColor: "#3a57e8",
              borderColor: "#3a57e8",
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
            }}
            onClick={handleCancelDiscard}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Products Modal */}
      <AddProductsModal
        show={productsViewModel}
        onHide={handleCloseProductsView}
        onAddProducts={handleAddProducts}
        systems={systems}
        phases={phases}
        optionsSystem={optionsSystem}
        fetchProductSuggestions={fetchProductSuggestions}
        selectedProductListIds={selectedProductListIds}
        activeSystemId={activeSystemId}
        activePhaseId={activePhaseId}
        token={token}
      />

      <div className="bomBody" style={{ borderRadius: "8px" }}>
        <div className="bomContainer" ref={alertRef}>
          <div className="breadcrumbRow noPrint">
            <div className="breadcrumbNav text-primary card-title">
              <h4
                onClick={() => navigate("/dashboard/app/job-list")}
                className="breadcrumbLink"
              >
                Job
              </h4>
              <h4 className="breadcrumbSeparator mx-2 card-title">{">"}</h4>
              <h4
                onClick={() => navigate(`/dashboard/app/job-edit/${jobId}`)}
                className="breadcrumbLink text-primary card-title"
              >
                {jobName || "Loading..."}
              </h4>
              <h4 className="breadcrumbSeparator mx-2 card-title">{">"}</h4>

              <h4 className="breadcrumbActive card-title">
                {bomInfo.bomNumber || "Loading..."}
              </h4>
            </div>

            {(hasBomPrintPermission ||
              decodedToken?.roles?.some(
                (role) => role.role_type === roleTypes.SUPER_ADMIN
              )) && (
                <div
                  className="printButtonContainer noPrint"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <button
                    onClick={handleDownloadPDF}
                    disabled={totals?.totalProducts < 1}
                    style={{
                      opacity: totals?.totalProducts < 1 && "0.6",
                      cursor: totals?.totalProducts < 1 && "no-drop",
                      whiteSpace: "nowrap",
                    }}
                    className="printButton"
                  >
                    Download PDF
                  </button>
                  <button
                    disabled={totals?.totalProducts < 1}
                    style={{
                      opacity: totals?.totalProducts < 1 && "0.6",
                      cursor: totals?.totalProducts < 1 && "no-drop",
                      whiteSpace: "nowrap",
                    }}
                    onClick={handlePrint}
                    className="printButton"
                  >
                    Print BOM
                  </button>
                </div>
              )}
          </div>

          <div ref={printContentRef} style={{ display: "none" }}>
            <div className="page-header">
              <img src={logo} alt="Coyote Logo" className="printLogo" />
              <div className="printTitle">
                <h1 className="printMainTitle">BILL OF MATERIALS (BOM)</h1>
                <p className="printBomNumber">
                  BOM Number:{" "}
                  <span className="printBold">
                    {bomInfo.bomNumber || "N/A"}
                  </span>
                </p>
              </div>
            </div>

            <div className="printMetadata">
              <div className="printMetadataRow">
                <div className="printMetadataItem">
                  <span className="printMetadataLabel">Project/Job:</span>{" "}
                  {bomInfo.jobName}
                </div>
                <div className="printMetadataItem">
                  <span className="printMetadataLabel">
                    Receiving Warehouse:
                  </span>{" "}
                  {bomInfo.warehouseName}
                </div>
              </div>
              <div className="printMetadataRow">
                <div className="printMetadataItem">
                  <span className="printMetadataLabel">Prepared By:</span>{" "}
                  {bomInfo.createdBy}
                </div>
                <div className="printMetadataItem">
                  <span className="printMetadataLabel">Date Generated:</span>{" "}
                  {formatDate(bomInfo.dateGenerated)}
                </div>
              </div>
            </div>

            {(() => {
              const productsToOrder = {};
              const inStockProducts = {};
              let hasProductsToOrder = false;
              let hasInStockProducts = false;

              Object.entries(bomData).forEach(([systemName, systemData]) => {
                const toOrder = systemData.filter(
                  (item) => item.qtyToOrder > 0
                );
                const inStock = systemData.filter(
                  (item) => item.qtyToOrder === 0
                );

                if (toOrder.length > 0) {
                  productsToOrder[systemName] = toOrder;
                  hasProductsToOrder = true;
                }
                if (inStock.length > 0) {
                  inStockProducts[systemName] = inStock;
                  hasInStockProducts = true;
                }
              });

              if (!hasProductsToOrder) {
                return (
                  <>
                    <h3 className="printHeading">Detailed Requirements</h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: Object.entries(bomData)
                          .map(([systemName, systemData]) =>
                            renderPrintSystemTable(systemName, systemData)
                          )
                          .join(""),
                      }}
                    />
                  </>
                );
              }

              let html = "";

              if (hasProductsToOrder) {
                html += '<h3 class="printHeading">Detailed Summary</h3>';
                html += Object.entries(productsToOrder)
                  .map(([systemName, systemData]) =>
                    renderPrintSystemTable(systemName, systemData)
                  )
                  .join("");
              }

              if (hasInStockProducts) {
                html +=
                  '<h3 class="printHeading" style="margin-top: 15px;">In-Stock Products</h3>';
                html += Object.entries(inStockProducts)
                  .map(([systemName, systemData]) =>
                    renderPrintSystemTable(systemName, systemData)
                  )
                  .join("");
              }

              return <div dangerouslySetInnerHTML={{ __html: html }} />;
            })()}

            <div className="printFooterNotes">
              <p>
                *The stock information in this report is accurate only at the
                moment of generation. Inventory levels may change afterward due
                to ongoing operations
              </p>
              <p>
                <strong>Qty Allocated</strong> are the number of units already
                reserved for other active jobs/BOMs (not including this job/BOM)
              </p>
            </div>

            <div className="printSignatureSection">
              <div className="printSignatureBox">
                <div className="printSignatureTitle">Prepared By:</div>
                <div className="printSignatureLine">
                  <span>Name / Title</span>
                  <div className="printLine"></div>
                </div>
                <div className="printSignatureLine">
                  <span>Signature</span>
                  <div className="printLine"></div>
                </div>
                <div className="printSignatureLine">
                  <span>Date</span>
                  <div className="printLine"></div>
                </div>
              </div>

              <div className="printSignatureBox">
                <div className="printSignatureTitle">Approved By:</div>
                <div className="printSignatureLine">
                  <span>Name / Title</span>
                  <div className="printLine"></div>
                </div>
                <div className="printSignatureLine">
                  <span>Signature</span>
                  <div className="printLine"></div>
                </div>
                <div className="printSignatureLine">
                  <span>Date</span>
                  <div className="printLine"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="bomHeader">
            <div className="logoSection">
              <img src={logo} alt="Coyote Logo" className="logoImage" />
            </div>
            <div className="titleSection">
              <h1 className="mainTitle">BILL OF MATERIALS (BOM)</h1>
              <p className="bomNumber">
                BOM Number:{" "}
                <span className="boldText">{bomInfo.bomNumber || "N/A"}</span>
              </p>
            </div>
          </div>

          <div className="metadataBox">
            <div className="metadataRow">
              <div className="metadataItem">
                <span className="metadataLabel">Project/Job:</span>{" "}
                {bomInfo.jobName}
              </div>
              <div className="metadataItem">
                <span className="metadataLabel">Receiving Warehouse:</span>{" "}
                {bomInfo.warehouseName}
              </div>
            </div>
            <div className="metadataRow">
              <div className="metadataItem">
                <span className="metadataLabel">Prepared By:</span>{" "}
                {bomInfo.createdBy}
              </div>
              <div className="metadataItem">
                <span className="metadataLabel">Date Generated:</span>{" "}
                {formatDate(bomInfo.dateGenerated)}
              </div>
            </div>
          </div>

          <div className="summaryGrid">
            <div className="summaryCard">
              <p className="summaryLabel">Total Products</p>
              <h3 className="summaryValue summaryInfo">
                {totals.totalProducts}
              </h3>
            </div>
            <div className="summaryCard">
              <p className="summaryLabel">Total Units Required</p>
              <h3 className="summaryValue summaryInfo">
                {totals.totalRequired}{" "}
                {totals.totalRequired !== null && "Units"}
              </h3>
            </div>
            <div className="summaryCard">
              <p className="summaryLabel">Available Units in Stock</p>
              <h3 className="summaryValue summaryInfo">
                {totals.totalAvailable}{" "}
                {totals.totalAvailable !== null && "Units"}
              </h3>
            </div>
            <div className="summaryCard">
              <p className="summaryLabel">Total Units To Order</p>
              <h3 className="summaryValue summaryDanger">
                {totals.totalToOrder} {totals.totalToOrder !== null && "Units"}
              </h3>
            </div>
          </div>

          <AlertNotificationSimple
            type={alert.type}
            message={alert.message}
            show={alert.show}
            onClose={() => setAlert({ ...alert, show: false })}
          />
          {newProducts.length > 0 && (
            <div className="mb-4 noPrint">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0 detailedHeading">New Products to Add</h3>
              </div>

              <Row className="mb-3">
                <Col md={12} lg={8}>
                  <Row>
                    <Col md={4} xxl={4}>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          placeholder="Search products"
                          value={searchNewProducts}
                          onChange={(e) => setSearchNewProducts(e.target.value)}
                          style={{
                            paddingTop: "7px",
                            paddingBottom: "7px",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} xxl={4} className="mt-md-0 mt-4">
                      <Select
                        closeMenuOnScroll={(e) => {
                          try {
                            const target = e.target;

                            if (
                              !target ||
                              !target.nodeType ||
                              typeof target.closest !== "function"
                            ) {
                              return true;
                            }

                            const isMenuScroll =
                              target.closest('[class*="MenuList"]') ||
                              target.closest('[class*="menu"]');

                            return !isMenuScroll;
                          } catch (error) {
                            return true;
                          }
                        }}
                        name="systemIdFilter"
                        options={optionsSystem}
                        value={selectedSystemForFilter}
                        onChange={(selectedOption) => {
                          setSelectedSystemForFilter(selectedOption || null);
                          if (!selectedOption) {
                            setSelectedPhaseForFilter(null);
                            setPhaseLoader(false);
                          } else {
                            setPhaseLoader(true);
                            setTimeout(() => {
                              setPhaseLoader(false);
                            }, 2000);
                          }
                        }}
                        isClearable
                        placeholder="Select System"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#007bff"
                              : state.isFocused
                                ? "#e6f7ff"
                                : "#fff",
                            color: "#333",
                            fontSize: "0.8rem",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          control: (provided) => ({
                            ...provided,
                            color: "#5e667b",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }),
                        }}
                      />
                    </Col>
                    <Col md={4} xxl={4} className="mt-md-0 mt-4">
                      <Select
                        closeMenuOnScroll={(e) => {
                          try {
                            const target = e.target;

                            if (
                              !target ||
                              !target.nodeType ||
                              typeof target.closest !== "function"
                            ) {
                              return true;
                            }

                            const isMenuScroll =
                              target.closest('[class*="MenuList"]') ||
                              target.closest('[class*="menu"]');

                            return !isMenuScroll;
                          } catch (error) {
                            return true;
                          }
                        }}
                        name="phaseIdFilter"
                        options={
                          selectedSystemForFilter
                            ? getFilteredPhasesForSystem(
                              selectedSystemForFilter.value
                            )
                            : []
                        }
                        value={
                          selectedSystemForFilter && selectedPhaseForFilter
                            ? selectedPhaseForFilter
                            : null
                        }
                        onChange={(selectedOption) => {
                          setSelectedPhaseForFilter(selectedOption || null);
                        }}
                        isClearable
                        isDisabled={!selectedSystemForFilter || phaseLoader}
                        isLoading={phaseLoader}
                        placeholder={
                          selectedSystemForFilter
                            ? "Select phase"
                            : "First select a system"
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#007bff"
                              : state.isFocused
                                ? "#e6f7ff"
                                : "#fff",
                            color: "#333",
                            fontSize: "0.8rem",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          control: (provided) => ({
                            ...provided,
                            color: "#5e667b",
                            backgroundColor:
                              !selectedSystemForFilter || phaseLoader
                                ? "#e9ecef"
                                : "#fff",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }),
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={12} lg={4} className="mt-lg-0 mt-4">
                  <Row>
                    <Col md={12} xxl={12}>
                      <div
                        className="d-flex justify-content-end"
                        style={{ gap: "0.5rem" }}
                      >
                        {isEditingAllowed() &&
                          hasBomCreatePRPermission &&
                          decodedToken?.roles?.some(
                            (role) => role.role_type !== roleTypes.SUPER_ADMIN
                          ) && (
                            <Button
                              onClick={handleOpenCreatePRModal}
                              className="btn btn-primary"
                              disabled={
                                totals?.totalToOrder <= 0 &&
                                totals.totalToOrder !== null
                              }
                            >
                              Create PR
                            </Button>
                          )}
                        {isEditingAllowed() &&
                          (hasBomEditPermission ||
                            decodedToken?.roles?.some(
                              (role) => role.role_type === roleTypes.SUPER_ADMIN
                            )) && (
                            <Button
                              onClick={() => {
                                const allProductIds = [
                                  ...Object.values(bomData)
                                    .flat()
                                    .map((item) => item.id),
                                  ...newProducts.map((item) => item.productId),
                                ];
                                setSelectedProductListIds(allProductIds);
                                setProductsViewModel(true);
                                setSearchNewProducts("");
                                setSelectedSystemForFilter(null);
                                setSelectedPhaseForFilter(null);
                              }}
                              className="btn btn-primary "
                            >
                              Add Products
                            </Button>
                          )}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="tableWrapper" style={{ position: "relative" }}>
                {isMerging && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div className="d-flex flex-column align-items-center">
                      <Spinner
                        animation="border"
                        role="status"
                        variant="primary"
                        size="lg"
                        style={{
                          width: "3rem",
                          height: "3rem",
                        }}
                      />
                      <span
                        className="mt-3 text-primary"
                        style={{ fontSize: "1rem", fontWeight: "500" }}
                      >
                        Processing products...
                      </span>
                    </div>
                  </div>
                )}
                <Table
                  className="dataTable"
                  style={{
                    opacity: isMerging ? 0.5 : 1,
                    transition: "opacity 0.3s ease",
                    overflow: "auto",
                  }}
                >
                  <thead className="bg-selected-product">
                    <tr>
                      <th
                        onClick={() => handleSortNewProducts("productName")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-row align-items-end user-select-none">
                          Product Name{" "}
                          <span className="d-flex flex-column ms-2">
                            <BsCaretUpFill
                              color={
                                sortConfigNewProducts.key === "productName" &&
                                  sortConfigNewProducts.direction === "asc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                            <BsCaretDownFill
                              color={
                                sortConfigNewProducts.key === "productName" &&
                                  sortConfigNewProducts.direction === "desc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                          </span>
                        </div>
                      </th>
                      <th style={{ minWidth: "100px" }}>Quantity</th>
                      <th
                        onClick={() =>
                          handleSortNewProducts("manufacturerName")
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-row align-items-end user-select-none">
                          Make{" "}
                          <span className="d-flex flex-column ms-2">
                            <BsCaretUpFill
                              color={
                                sortConfigNewProducts.key ===
                                  "manufacturerName" &&
                                  sortConfigNewProducts.direction === "asc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                            <BsCaretDownFill
                              color={
                                sortConfigNewProducts.key ===
                                  "manufacturerName" &&
                                  sortConfigNewProducts.direction === "desc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                          </span>
                        </div>
                      </th>
                      <th
                        onClick={() => handleSortNewProducts("model")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-row align-items-end user-select-none">
                          Model{" "}
                          <span className="d-flex flex-column ms-2">
                            <BsCaretUpFill
                              color={
                                sortConfigNewProducts.key === "model" &&
                                  sortConfigNewProducts.direction === "asc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                            <BsCaretDownFill
                              color={
                                sortConfigNewProducts.key === "model" &&
                                  sortConfigNewProducts.direction === "desc"
                                  ? "#3a57e8"
                                  : "#ccc"
                              }
                            />
                          </span>
                        </div>
                      </th>
                      <th style={{ minWidth: "200px" }}>SKU</th>
                      <th style={{ minWidth: "200px" }}>Rate</th>
                      <th style={{ minWidth: "200px" }}>Amount</th>
                      <th style={{ minWidth: "200px" }}>System</th>
                      <th style={{ minWidth: "200px" }}>Phase</th>
                      <th style={{ minWidth: "100px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getPaginatedNewProducts().map((item, index) => {
                      const uniqueKey = createUniqueKey(
                        item.productId,
                        item.systemId,
                        item.phaseId
                      );
                      const isRecentlyAdded =
                        recentlyAddedProducts.has(uniqueKey);
                      const hasAnyError = validationErrors[uniqueKey];

                      return (
                        <tr
                          key={uniqueKey}
                          className={
                            isRecentlyAdded
                              ? "bg-new-product-row"
                              : "bg-selected-product"
                          }
                          style={{
                            border: hasAnyError ? "2px solid #dc3545" : "none",
                          }}
                        >
                          <td>
                            <Form.Control
                              readOnly
                              type="text"
                              value={item.productName || ""}
                              style={{
                                width: "200px",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td
                            className={
                              highlightedQuantities.has(uniqueKey)
                                ? "quantity-cell-highlight"
                                : ""
                            }
                          >
                            <Form.Control
                              type="text"
                              value={item.quantity || ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                if (validationErrors[uniqueKey]?.quantity) {
                                  setValidationErrors((prev) => {
                                    const newErrors = { ...prev };
                                    if (newErrors[uniqueKey]) {
                                      delete newErrors[uniqueKey].quantity;
                                      if (
                                        Object.keys(newErrors[uniqueKey])
                                          .length === 0
                                      ) {
                                        delete newErrors[uniqueKey];
                                      }
                                    }
                                    return newErrors;
                                  });
                                }

                                setHighlightedQuantities((prev) =>
                                  new Set(prev).add(uniqueKey)
                                );

                                setTimeout(() => {
                                  setHighlightedQuantities((prev) => {
                                    const newSet = new Set(prev);
                                    newSet.delete(uniqueKey);
                                    return newSet;
                                  });
                                }, 5000);

                                if (value === "") {
                                  const updatedProducts = newProducts.map((p) =>
                                    createUniqueKey(
                                      p.productId,
                                      p.systemId,
                                      p.phaseId
                                    ) === uniqueKey
                                      ? { ...p, quantity: "", amount: "" }
                                      : p
                                  );
                                  setNewProducts(updatedProducts);
                                  return;
                                }

                                if (!/^\d+$/.test(value)) {
                                  return;
                                }

                                const parsedValue = parseInt(value, 10);
                                let existingQuantity = 0;
                                Object.keys(bomData).forEach((systemName) => {
                                  const systemProducts =
                                    bomData[systemName] || [];
                                  const existingItem = systemProducts.find(
                                    (existing) =>
                                      createUniqueKey(
                                        existing.productId,
                                        existing.systemId,
                                        existing.phaseId
                                      ) === uniqueKey
                                  );
                                  if (existingItem) {
                                    existingQuantity =
                                      existingItem.qtyRequired || 0;
                                  }
                                });

                                const maxAdditional = Math.max(
                                  MAX_QUANTITY_ALLOWED - existingQuantity,
                                  0
                                );

                                if (
                                  value.length > 5 ||
                                  parsedValue > MAX_QUANTITY_ALLOWED
                                ) {
                                  setValidationErrors((prev) => ({
                                    ...prev,
                                    [uniqueKey]: {
                                      ...prev[uniqueKey],
                                      quantity: `Maximum quantity allowed is ${MAX_QUANTITY_ALLOWED} per product per system per phase. You can add up to ${maxAdditional} more.`,
                                    },
                                  }));
                                  return;
                                }

                                const totalQuantity =
                                  existingQuantity + parsedValue;

                                if (totalQuantity > MAX_QUANTITY_ALLOWED) {
                                  setValidationErrors((prev) => ({
                                    ...prev,
                                    [uniqueKey]: {
                                      ...prev[uniqueKey],
                                      quantity: `Maximum quantity allowed is ${MAX_QUANTITY_ALLOWED} per product per system per phase. You can add up to ${maxAdditional} more.`,
                                    },
                                  }));
                                } else if (
                                  validationErrors[uniqueKey]?.quantity
                                ) {
                                  setValidationErrors((prev) => {
                                    const newErrors = { ...prev };
                                    if (newErrors[uniqueKey]) {
                                      delete newErrors[uniqueKey].quantity;
                                      if (
                                        Object.keys(newErrors[uniqueKey])
                                          .length === 0
                                      ) {
                                        delete newErrors[uniqueKey];
                                      }
                                    }
                                    return newErrors;
                                  });
                                }

                                if (
                                  !isNaN(parsedValue) &&
                                  parsedValue.toString() === value &&
                                  parsedValue >= 0
                                ) {
                                  const updatedAmount = (
                                    parsedValue * (item.rate ?? 0)
                                  ).toFixed(2);
                                  const updatedProducts = newProducts.map((p) =>
                                    createUniqueKey(
                                      p.productId,
                                      p.systemId,
                                      p.phaseId
                                    ) === uniqueKey
                                      ? {
                                        ...p,
                                        quantity: parsedValue,
                                        amount: updatedAmount,
                                      }
                                      : p
                                  );
                                  setNewProducts(updatedProducts);
                                }
                              }}
                              style={{
                                width: "100px",
                                fontSize: "0.8rem",
                                borderColor: hasError(uniqueKey, "quantity")
                                  ? "#dc3545"
                                  : "",
                                boxShadow: hasError(uniqueKey, "quantity")
                                  ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                                  : "",
                              }}
                              isInvalid={hasError(uniqueKey, "quantity")}
                            />
                            {hasError(uniqueKey, "quantity") && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontSize: "0.75rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                {getErrorMessage(uniqueKey, "quantity")}
                              </div>
                            )}
                          </td>
                          <td>
                            <Form.Control
                              readOnly
                              type="text"
                              value={item.manufacturerName || ""}
                              style={{
                                width: "200px",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control
                              readOnly
                              type="text"
                              value={item.model || ""}
                              style={{
                                resize: "none",
                                width: "auto",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control
                              readOnly
                              type="text"
                              value={item.sku || ""}
                              style={{
                                resize: "none",
                                width: "auto",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                       
                          
                          <td>
                            <Form.Control
                              type="text"
                              step="0.01"
                              min={0}
                              value={item.rate ?? ""}
                              onChange={(e) => {
                                const inputValue = e.target.value;

                                if (validationErrors[uniqueKey]?.rate) {
                                  setValidationErrors((prev) => {
                                    const newErrors = { ...prev };
                                    if (newErrors[uniqueKey]) {
                                      delete newErrors[uniqueKey].rate;
                                      if (
                                        Object.keys(newErrors[uniqueKey])
                                          .length === 0
                                      ) {
                                        delete newErrors[uniqueKey];
                                      }
                                    }
                                    return newErrors;
                                  });
                                }

                                if (inputValue === "") {
                                  const updatedProducts = newProducts.map((p) =>
                                    createUniqueKey(
                                      p.productId,
                                      p.systemId,
                                      p.phaseId
                                    ) === uniqueKey
                                      ? {
                                        ...p,
                                        rate: "",
                                        amount: parseFloat("0.00"),
                                      }
                                      : p
                                  );
                                  setNewProducts(updatedProducts);
                                  return;
                                }

                                if (!/^\d*\.?\d{0,2}$/.test(inputValue)) {
                                  return;
                                }

                                const [integerPart] = inputValue.split(".");
                                if (integerPart && integerPart.length > 13) {
                                  return;
                                }

                                const numericValue = parseFloat(inputValue);
                                if (
                                  !isNaN(numericValue) &&
                                  numericValue > 9999999999999.99
                                ) {
                                  return;
                                }

                                const updatedAmount =
                                  inputValue && item.quantity
                                    ? (
                                      parseFloat(inputValue) * item.quantity
                                    ).toFixed(2)
                                    : "0.00";

                                const updatedProducts = newProducts.map((p) =>
                                  createUniqueKey(
                                    p.productId,
                                    p.systemId,
                                    p.phaseId
                                  ) === uniqueKey
                                    ? {
                                      ...p,
                                      rate: inputValue,
                                      amount: parseFloat(updatedAmount),
                                    }
                                    : p
                                );
                                setNewProducts(updatedProducts);
                              }}
                              style={{
                                width: "200px",
                                fontSize: "0.8rem",
                                borderColor: hasError(uniqueKey, "rate")
                                  ? "#dc3545"
                                  : "",
                                boxShadow: hasError(uniqueKey, "rate")
                                  ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                                  : "",
                              }}
                              isInvalid={hasError(uniqueKey, "rate")}
                            />
                            {hasError(uniqueKey, "rate") && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontSize: "0.75rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                {getErrorMessage(uniqueKey, "rate")}
                              </div>
                            )}
                          </td>
                          <td style={{ width: "200px" }}>
                            <Form.Control
                              type="text"
                              step="0.01"
                              min={0}
                              value={item.amount || 0}
                              readOnly
                              style={{
                                width: "200px",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td>
                            <Select
                              closeMenuOnScroll={(e) => {
                                try {
                                  const target = e.target;

                                  if (
                                    !target ||
                                    !target.nodeType ||
                                    typeof target.closest !== "function"
                                  ) {
                                    return true;
                                  }

                                  const isMenuScroll =
                                    target.closest('[class*="MenuList"]') ||
                                    target.closest('[class*="menu"]');

                                  return !isMenuScroll;
                                } catch (error) {
                                  return true;
                                }
                              }}
                              name="systemId"
                              options={optionsSystem}
                              value={optionsSystem.find(
                                (option) => option.value === item.systemId
                              )}
                              onChange={(selectedOption) => {
                                if (validationErrors[uniqueKey]?.systemId) {
                                  setValidationErrors((prev) => {
                                    const newErrors = { ...prev };
                                    if (newErrors[uniqueKey]) {
                                      delete newErrors[uniqueKey].systemId;
                                      if (
                                        Object.keys(newErrors[uniqueKey])
                                          .length === 0
                                      ) {
                                        delete newErrors[uniqueKey];
                                      }
                                    }
                                    return newErrors;
                                  });
                                }

                                const newSystemId =
                                  selectedOption?.value || null;
                                handleSystemPhaseChange(uniqueKey, {
                                  systemId: newSystemId,
                                  phaseId: null,
                                });
                              }}
                              isClearable
                              placeholder="Select System"
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              menuPlacement="auto"
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  width: "100%",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "#007bff"
                                    : state.isFocused
                                      ? "#e6f7ff"
                                      : "#fff",
                                  color: "#333",
                                  fontSize: "0.8rem",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  color: "#5e667b",
                                  borderColor: hasError(uniqueKey, "systemId")
                                    ? "#dc3545"
                                    : provided.borderColor,
                                  boxShadow: hasError(uniqueKey, "systemId")
                                    ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                                    : provided.boxShadow,
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }),
                              }}
                            />
                            {hasError(uniqueKey, "systemId") && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontSize: "0.75rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                {getErrorMessage(uniqueKey, "systemId")}
                              </div>
                            )}
                          </td>
                          <td>
                            <Select
                              closeMenuOnScroll={(e) => {
                                try {
                                  const target = e.target;

                                  if (
                                    !target ||
                                    !target.nodeType ||
                                    typeof target.closest !== "function"
                                  ) {
                                    return true;
                                  }

                                  const isMenuScroll =
                                    target.closest('[class*="MenuList"]') ||
                                    target.closest('[class*="menu"]');

                                  return !isMenuScroll;
                                } catch (error) {
                                  return true;
                                }
                              }}
                              name="phaseId"
                              options={getFilteredPhasesForSystem(
                                item.systemId
                              )}
                              value={
                                item.systemId && item.phaseId
                                  ? getFilteredPhasesForSystem(
                                    item.systemId
                                  ).find(
                                    (option) => option.value === item.phaseId
                                  )
                                  : null
                              }
                              onChange={(selectedOption) => {
                                if (validationErrors[uniqueKey]?.phaseId) {
                                  setValidationErrors((prev) => {
                                    const newErrors = { ...prev };
                                    if (newErrors[uniqueKey]) {
                                      delete newErrors[uniqueKey].phaseId;
                                      if (
                                        Object.keys(newErrors[uniqueKey])
                                          .length === 0
                                      ) {
                                        delete newErrors[uniqueKey];
                                      }
                                    }
                                    return newErrors;
                                  });
                                }

                                handleSystemPhaseChange(uniqueKey, {
                                  phaseId: selectedOption?.value || null,
                                });
                              }}
                              isClearable
                              placeholder={
                                item.systemId
                                  ? "Select phase"
                                  : "First select a system"
                              }
                              isDisabled={!item.systemId}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              menuPlacement="auto"
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  width: "100%",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "#007bff"
                                    : state.isFocused
                                      ? "#e6f7ff"
                                      : "#fff",
                                  color: "#333",
                                  fontSize: "0.8rem",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  color: "#5e667b",
                                  backgroundColor: !item.systemId
                                    ? "#e9ecef"
                                    : "#fff",
                                  borderColor: hasError(uniqueKey, "phaseId")
                                    ? "#dc3545"
                                    : provided.borderColor,
                                  boxShadow: hasError(uniqueKey, "phaseId")
                                    ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                                    : provided.boxShadow,
                                }),
                              }}
                            />
                            {hasError(uniqueKey, "phaseId") && (
                              <div
                                style={{
                                  color: "#dc3545",
                                  fontSize: "0.75rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                {getErrorMessage(uniqueKey, "phaseId")}
                              </div>
                            )}
                          </td>
                          <td style={{ textWrap: "unset" }}>
                            <Link>
                              <Tooltip title="Remove">
                                <IconButton
                                  size="medium"
                                  color="error"
                                  onClick={() => {
                                    setNewProducts((prevProducts) =>
                                      prevProducts.filter(
                                        (p) =>
                                          createUniqueKey(
                                            p.productId,
                                            p.systemId,
                                            p.phaseId
                                          ) !== uniqueKey
                                      )
                                    );
                                    setValidationErrors((prev) => {
                                      const newErrors = { ...prev };
                                      delete newErrors[uniqueKey];
                                      return newErrors;
                                    });
                                  }}
                                >
                                  <CancelIcon fontSize="medium" />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}

                    {hasMoreNewProducts() && (
                      <tr>
                        <div
                          style={{
                            position: "sticky",
                            bottom: "0",
                            left: "45%",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "white",
                            padding: "1rem 0",
                            zIndex: 10,
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-lg px-4 py-2 mb-2"
                            onClick={() => {
                              setIsLoadingMoreNewProducts(true);
                              loadMoreNewProducts();
                              setTimeout(() => {
                                setIsLoadingMoreNewProducts(false);
                              }, 300);
                            }}
                            disabled={isLoadingMoreNewProducts}
                            style={{
                              borderRadius: "20px",
                              fontWeight: "400",
                              fontSize: "14px",
                              minWidth: "150px",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {isLoadingMoreNewProducts ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Loading...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-plus-circle me-2" />
                                Load More
                              </>
                            )}
                          </button>
                        </div>
                      </tr>
                    )}

                    {getPaginatedNewProducts().length === 0 && (
                      <tr>
                        <td colSpan="12">
                          <div
                            style={{ padding: "2rem 0", textAlign: "center" }}
                          >
                            <p className="mb-0 text-muted">
                              No products match your search criteria
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              <div
                className="d-flex justify-content-end mt-3"
                style={{ gap: "0.5rem" }}
              >
                <Button
                  type="button"
                  className="px-3 px-md-4"
                  variant="btn btn-light"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                <Button
                  onClick={handleUpdate}
                  type="button"
                  className="px-3 px-md-4"
                  variant="btn btn-primary"
                  disabled={isSubmitting || !isEditingAllowed()}
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </div>
            </div>
          )}
          <div className="d-flex flex-md-row flex-column justify-content-between align-items-start  align-items-md-center mb-3 mt-4 noPrint">
            <h3 className="mb-0 detailedHeading ">Existing BOM Products</h3>
            {newProducts.length === 0 && (
              <div
                className="d-flex mt-3 align-items-end justify-content-end  mt-md-0 pr-button-mobile"
                style={{ gap: "0.5rem" }}
              >
                {isEditingAllowed() &&
                  hasBomCreatePRPermission &&
                  decodedToken?.roles?.some(
                    (role) => role.role_type !== roleTypes.SUPER_ADMIN
                  ) && (
                    <Button
                      onClick={handleOpenCreatePRModal}
                      type="button"
                      variant="btn btn-primary"
                      className="px-3 px-md-4"
                      disabled={
                        totals?.totalToOrder <= 0 &&
                        totals.totalToOrder !== null
                      }
                    >
                      Create PR
                    </Button>
                  )}
                {isEditingAllowed() &&
                  (hasBomEditPermission ||
                    decodedToken?.roles?.some(
                      (role) => role.role_type === roleTypes.SUPER_ADMIN
                    )) && (
                    <Button
                      onClick={() => {
                        const allProductIds = [
                          ...Object.values(bomData)
                            .flat()
                            .map((item) => item.id),
                          ...newProducts.map((item) => item.productId),
                        ];
                        setSelectedProductListIds(allProductIds);
                        setProductsViewModel(true);
                        setSearchNewProducts("");
                        setSelectedSystemForFilter(null);
                        setSelectedPhaseForFilter(null);
                      }}
                      type="button"
                      variant="btn btn-primary"
                      className="btn btn-primary px-3 px-md-4"
                    >
                      Add Products
                    </Button>
                  )}
              </div>
            )}
          </div>

          {Object.keys(bomData).length === 0 ? (
            <div className="alertInfo">
              No existing products found in this BOM
            </div>
          ) : (
            Object.entries(bomData).map(([systemName, systemData]) =>
              renderSystemTable(systemName, systemData)
            )
          )}

          <div
            className="d-flex flex-wrap flex-md-nowrap justify-content-end mt-4 noPrint"
            style={{ gap: "0.5rem" }}
          >
            <Button
              type="button"
              variant="btn btn-primary"
              className="px-3 px-md-4"
              disabled={
                totals?.totalProducts < 1 ||
                isSubmittingAvailability ||
                isUpdateAvailabilityEnabled ||
                !isEditingAllowed()
              }
              onClick={handleUpdateAvailability}
            >
              {isSubmittingAvailability ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Check and Save Availability...
                </>
              ) : (
                "Check and Save Availability"
              )}
            </Button>
          </div>

          <div className="footerNotes">
            <p className="footerText">
              *The stock information in this report is accurate only at the
              moment of generation. Inventory levels may change afterward due to
              ongoing operations
            </p>
            <p className="footerText">
              <strong>Qty Required</strong> are the total number of units needed
              to complete this job
            </p>
            <p className="footerText">
              <strong>Qty In Stock</strong> are the total number of units
              currently present in the warehouse, including both allocated
              (reserved for jobs) and unallocated (free) units (Qty Allocated +
              Net Available)
            </p>
            <p className="footerText">
              <strong>Qty Allocated</strong> are the number of units already
              reserved for other active jobs/BOMs (not including this job/BOM)
            </p>
            <p className="footerText">
              <strong>Net Available</strong> are the number of units in the
              warehouse that are not allocated to any job, fully free and
              available for use
            </p>
            <p className="footerText">
              <strong>Qty To Order</strong> are the number of units that must be
              purchased because the warehouse does not have enough free (Net
              Available) stock(Qty Required – Net Available)
            </p>
          </div>

          <div className="companyFooter">
            <p className="companyInfo">
              Coyote Cabling, Inc. • 123 Copper Way, Dallas, TX 75201 •
              procurement@coyotecabling.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobBomEdit;
